var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecisionTaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM10.9 19.7V17.5H13.1V19.7H10.9ZM14.387 12.187L15.377 11.175C16.499 10.053 16.884 8.12797 15.586 6.33497C14.596 4.95997 13.001 4.09097 11.329 4.35497C9.62399 4.61897 8.24899 5.85097 7.77599 7.46797C7.59999 8.08397 8.03999 8.69997 8.67799 8.69997H9.00799C9.43699 8.69997 9.77799 8.39197 9.90999 7.98497C10.273 6.93997 11.406 6.24697 12.627 6.58797C13.397 6.80797 14.013 7.47897 14.156 8.27097C14.299 9.04097 14.057 9.76697 13.551 10.251L12.187 11.637C11.725 12.099 11.362 12.671 11.142 13.309C10.988 13.76 10.9 14.244 10.9 14.75V15.3H13.1C13.1 14.794 13.155 14.398 13.243 14.046C13.441 13.254 13.837 12.748 14.387 12.187Z",
    fill: "#54AF48"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-decision-taking",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM10.9 19.7V17.5H13.1V19.7H10.9ZM14.387 12.187L15.377 11.175C16.499 10.053 16.884 8.12797 15.586 6.33497C14.596 4.95997 13.001 4.09097 11.329 4.35497C9.62399 4.61897 8.24899 5.85097 7.77599 7.46797C7.59999 8.08397 8.03999 8.69997 8.67799 8.69997H9.00799C9.43699 8.69997 9.77799 8.39197 9.90999 7.98497C10.273 6.93997 11.406 6.24697 12.627 6.58797C13.397 6.80797 14.013 7.47897 14.156 8.27097C14.299 9.04097 14.057 9.76697 13.551 10.251L12.187 11.637C11.725 12.099 11.362 12.671 11.142 13.309C10.988 13.76 10.9 14.244 10.9 14.75V15.3H13.1C13.1 14.794 13.155 14.398 13.243 14.046C13.441 13.254 13.837 12.748 14.387 12.187Z",
    fill: "#5D6B72"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-decision-taking)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#54AF48"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionTaking);
export default __webpack_public_path__ + "static/media/DecisionTaking.75a92055.svg";
export { ForwardRef as ReactComponent };